export function getImgAspectRatio(img: any, newHeight: number, newWidth: number): { [key: string]: number } {
  const { height: oldHeight, width: oldWidth } = img;
  const isNewHeight = Boolean(newHeight);

  return {
    [(isNewHeight ? 'height' : 'width')]: (isNewHeight ? newHeight : newWidth),
    [(isNewHeight ? 'width' : 'height')]: (isNewHeight ? (newHeight * (oldWidth / oldHeight)) : (newWidth * (oldHeight / oldWidth))),
  };
}
